import { cssClass } from '../../style';
import { TypeStyle, classes } from 'typestyle';
import { NestedCSSProperties } from 'typestyle/lib/types';
import { CommonStyles } from '../../common/react/CommonStyles';

const cssPrefix = 'AnalyticsExtensionsSettings';

export namespace AnalyticsExtensionsSettingsStyles {

    export const enableForSite = cssClass(cssPrefix, 'enable-for-site', {
      margin: '10px 0 10px 0'
    });

    export const editDialogSection = cssClass(cssPrefix, 'edit-dialog-section', {
      display: 'block',
      width: '395px',
      margin: -CommonStyles.Sizes.LargeSpace,
      overflow: 'hidden'
    });

    export const editDialogTitle = cssClass(cssPrefix, 'edit-dialog-title', {
      display: 'block',
      width: '100%',
      fontSize: CommonStyles.Sizes.HeaderFontSize,
      color: CommonStyles.Colors.Grey77,
      marginBottom: CommonStyles.Sizes.LargeSpace,
      padding: [CommonStyles.Sizes.MediumSpace, 0, CommonStyles.Sizes.SmallSpace, CommonStyles.Sizes.MediumSpace],
      backgroundColor: CommonStyles.Colors.Grey245
    });

    export const editDialogDescription = cssClass(cssPrefix, 'edit-dialog-description', {
      display: 'block',
      width: '100%',
      color: CommonStyles.Colors.Grey77,
      paddingBottom: CommonStyles.Sizes.LargeSpace,
      paddingLeft: CommonStyles.Sizes.MediumSpace,
      paddingRight: CommonStyles.Sizes.MediumSpace,
      marginRight: CommonStyles.Sizes.MediumSpace
    });

    export const editDialogBlock = cssClass(cssPrefix, 'edit-dialog-block', {
      display: 'block',
      width: '100%',
      paddingBottom: CommonStyles.Sizes.LargeSpace,
      paddingLeft: CommonStyles.Sizes.MediumSpace,
      paddingRight: CommonStyles.Sizes.LargeSpace
    });

    export const editDialogInputBlock = cssClass(cssPrefix, 'edit-dialog-input-block', {
      display: 'block',
      paddingBottom: CommonStyles.Sizes.SmallSpace
    });

    export const editDialogInputInline = cssClass(cssPrefix, 'edit-dialog-input-inline', {
      display: 'inline',
      verticalAlign: 'bottom',
      paddingLeft: CommonStyles.Sizes.LargeSpace,
      paddingBottom: CommonStyles.Sizes.SmallSpace
    });

    export const editDialogProtocolLabel = cssClass(cssPrefix, 'edit-dialog-protocol-label', {
      display: 'inline-block',
      width: '46px'
    });

    export const editDialogTabPyHostInput = cssClass(cssPrefix, 'edit-dialog-tabpy-host-input', {
      $nest: {
        '& input': {
          width: '201px'
        }
      }
    });

    export const editDialogHostInput = cssClass(cssPrefix, 'edit-dialog-host-input', {
      $nest: {
        '& input': {
          width: '265px'
        }
      }
    });

    export const editDialogPortInput = cssClass(cssPrefix, 'edit-dialog-port-input', {
      $nest: {
        '& input': {
          width: '60px'
        }
      }
    });

    export const editDialogUserNameInput = cssClass(cssPrefix, 'edit-dialog-user-name-input', {
      $nest: {
        '& input': {
          width: '162px'
        }
      }
    });

    export const editDialogPasswordInput = cssClass(cssPrefix, 'edit-dialog-password-input', {
      $nest: {
        '& input': {
          width: '162px'
        }
      }
    });

    export const editDialogActions = cssClass(cssPrefix, 'edit-dialog-actions', {
      float: 'right',
      marginBottom: CommonStyles.Sizes.LargeSpace
    });

    export const editDialogCancel = cssClass(cssPrefix, 'edit-dialog-cancel', {
      display: 'inline',
      paddingRight: CommonStyles.Sizes.MediumSpace
    });

    export const editDialogSave = cssClass(cssPrefix, 'edit-dialog-create', {
      display: 'inline',
      paddingRight: CommonStyles.Sizes.LargeSpace,
      marginRight: CommonStyles.Sizes.LargeSpace
    });

    export const connectionSettingsTable = cssClass(cssPrefix, 'connection-settings-table', {
      display: 'table',
      width: '100%'
    });

    export const connectionSettingsRow = cssClass(cssPrefix, 'connection-settings-row', {
      display: 'table-row',
      fontWeight: 'bold',
      margin: '4px 0px 4px 0'
    });

    export const connectionSettingsCell = cssClass(cssPrefix, 'connection-setting-cell', {
      display: 'table-cell',
      padding: '0px 5px 0px 5px',
      verticalAlign: 'bottom'
    });

    export const connectionRow = cssClass(cssPrefix, 'connection-settings-row', {
      display: 'table-row',
      margin: '4px 2px 4px 2px',
      width: '100%'
    });

    export const connectionHeaderCell = cssClass(cssPrefix, 'connection-header-cell', {
      display: 'table-cell',
      borderBottomStyle: 'solid',
      borderColor: '#E6E6E6',
      background: '#FAFAFA',
      borderTopStyle: 'solid',
      borderWidth: 'thin',
      fontSize: '13px',
      fontWeight: 'bold',
      padding: '2px 5px 2px 5px',
      verticalAlign: 'bottom'
    });

    export const connectionCell = cssClass(cssPrefix, 'connection-setting-cell', {
      display: 'table-cell',
      borderBottomStyle: 'solid',
      borderColor: '#E6E6E6',
      borderWidth: 'thin',
      fontWeight: 'normal',
      padding: '2px 5px 2px 5px',
      position: 'relative',
      verticalAlign: 'bottom'
    });

    export const emptyConnectionPrompt = cssClass(cssPrefix, 'no-connection-prompt', {
      display: 'table-cell',
      borderBottomStyle: 'solid',
      borderColor: '#E6E6E6',
      borderWidth: 'thin',
      fontStyle: 'italic',
      padding: '2px 5px 2px 5px',
      verticalAlign: 'bottom',
      width: '100%'
    });

    export const Hide = cssClass(cssPrefix, 'connection-setting-checkbox-hidden', {
     display: 'none'
    });

    export const connectionPortInput = cssClass(cssPrefix, 'connection-port-input', {
      $nest: {
        '& input': {
          width: '60px'
        }
      }
    });

    export const connectionSslCheckbox: React.CSSProperties = {
      width: '96px'
    };

    export const connectionDeleteConfirmationDialogHeader = cssClass(cssPrefix, 'connection-delete-confirmation-dialog-header', {
      marginTop: CommonStyles.Sizes.SmallSpace,
      marginBottom: CommonStyles.Sizes.MediumSpace
    });

    export const connectionDeleteConfirmationDialogDescription = cssClass(cssPrefix, 'connection-delete-confirmation-dialog-description', {
      fontSize: CommonStyles.Sizes.NormalFontSize,
    });
}
